var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('h4',{staticClass:"title overflow",attrs:{"title":_vm.card.name}},[_vm._v(_vm._s(_vm.card.name))]),_c(_vm.fixTypeName(),{tag:"component",attrs:{"info":_vm.card}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }